import React, { useState } from "react";
import { useTheme } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AEROS } from "../../styles/aerosTokens";
import { descreveFalha } from "../../helpers/erroMeta";

// Linha sempre visivel sob a bolha de uma mensagem nao entregue (ack -1).
const FalhaDeEntrega = ({ message }) => {
  const theme = useTheme();
  const [aberto, setAberto] = useState(false);
  if (!message || message.ack !== -1) return null;

  const falha = descreveFalha(message);
  const light = theme?.palette?.type === "light";
  const cor = light ? AEROS.stateTextOnLight.error : AEROS.error;
  const temDetalhes = falha.code !== null || !!falha.original;
  const alvo = { minHeight: 44, display: "inline-flex", alignItems: "center", boxSizing: "border-box" };

  return (
    <div
      data-testid="falha-de-entrega"
      style={{
        marginTop: 6,
        paddingLeft: 8,
        borderLeft: `3px solid ${cor}`,
        color: cor,
        fontSize: 13,
        lineHeight: 1.5,
        overflowWrap: "anywhere",
        maxWidth: "calc(100% + 74px)",
        // O texto do balao reserva 80px a direita para o horario (absoluto no
        // canto inferior). Sem ocupar essa reserva, o motivo virava uma coluna
        // de ~90px no celular (375px). A margem inferior deixa a linha do
        // horario (18px) livre embaixo dos links.
        marginRight: -74,
        marginBottom: 14,
      }}
    >
      <span>
        {i18n.t("metaErrors.failureLine", { titulo: falha.titulo })}
        {falha.acao ? ` ${falha.acao}.` : ""}
      </span>
      <div style={{ display: "flex", flexWrap: "wrap", columnGap: 16 }}>
        {falha.link && (
          <a
            href={falha.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ ...alvo, color: "inherit", fontWeight: 600, textDecoration: "underline" }}
          >
            {i18n.t("metaErrors.fixAt")}
          </a>
        )}
        {temDetalhes && (
          <button
            type="button"
            aria-expanded={aberto}
            onClick={() => setAberto(v => !v)}
            style={{
              ...alvo,
              background: "none",
              border: "none",
              padding: 0,
              color: "inherit",
              font: "inherit",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {aberto ? i18n.t("metaErrors.hideDetails") : i18n.t("metaErrors.showDetails")}
          </button>
        )}
      </div>
      {aberto && (
        <div style={{ fontSize: 12, opacity: 0.9, paddingBottom: 4 }}>
          {falha.code !== null && (
            <div>
              {i18n.t("metaErrors.technicalCode")}: {falha.code}
            </div>
          )}
          {falha.original && <div>{falha.original}</div>}
        </div>
      )}
    </div>
  );
};

export default FalhaDeEntrega;
